import mapActions from './mapActions';

export default mapActions('order_document_material_items', {
    fetchAll_url: (data) => {
        return `/api/orders/${data.orderId}/${data.documentType}/${data.schema}/${data.documentId}/material_items`;
    }
});